var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['pt-read-people-table']},[_c('wt-table',{attrs:{"labels":_vm.tableLabels,"list":_vm.tableData}},[_c('template',{slot:"before"},[_vm._t("before")],2),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }